import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

class Popup extends React.Component {
  constructor(props) {
    super(props);

    this.el = document.createElement('div');
    this.el.setAttribute('id', 'popup');
    this.el.setAttribute('style', 'position:absolute;height:90.5%;width:100%; top:62px; right:0; bottom:30px;left:0; z-index:9999999');
  }

  componentDidMount() {
    // console.log('PORTAL MOUNT')
    document.querySelector('#popup-container').appendChild(this.el);
  }

  componentWillUnmount() {
    // console.log('PORTAL UNMOUNT')
    document.querySelector('#popup-container').removeChild(this.el);
  }

  render() {
    
    const { children } = this.props;
    return ReactDOM.createPortal(children, this.el);
  }
}

Popup.propTypes = {
  children: PropTypes.element,
};

export default Popup;



// WEBPACK FOOTER //
// ./src/Components/Popup.jsx